(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementCountdown extends HTMLElement {
    connectedCallback() {
      this.end = new Date((this.dataset.end || '').replace(' ', 'T')).getTime();
      this.f = {
        d: this.querySelector('[data-cd-d]'),
        h: this.querySelector('[data-cd-h]'),
        m: this.querySelector('[data-cd-m]'),
        s: this.querySelector('[data-cd-s]'),
      };
      if (isNaN(this.end)) return;
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
    }
    tick() {
      const diff = this.end - new Date().getTime();
      if (diff <= 0) {
        clearInterval(this.interval);
        if (this.dataset.expired) {
          this.textContent = this.dataset.expired;
        } else {
          this.set(0, 0, 0, 0);
        }
        return;
      }
      const t = Math.floor(diff / 1000);
      this.set(Math.floor(t / 86400), Math.floor((t % 86400) / 3600), Math.floor((t % 3600) / 60), t % 60);
    }
    set(d, h, m, s) {
      const p = (n) => String(n).padStart(2, '0');
      if (this.f.d) this.f.d.textContent = p(d);
      if (this.f.h) this.f.h.textContent = p(h);
      if (this.f.m) this.f.m.textContent = p(m);
      if (this.f.s) this.f.s.textContent = p(s);
    }
  }
  if (!customElements.get('countdown-timer')) customElements.define('countdown-timer', AnnouncementCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurora-blog-posts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(wrap) {
      if (wrap.dataset.bpInit) return;
      var slider = wrap.querySelector('[id^="Slider-"]');
      var thumb = wrap.querySelector('.aurora-bp__progress-thumb');
      wrap.dataset.bpInit = '1';
      if (!slider || !thumb) return;
      function update() {
        var max = slider.scrollWidth - slider.clientWidth;
        var pct = Math.min(100, (slider.clientWidth / slider.scrollWidth) * 100);
        thumb.style.width = pct + '%';
        thumb.style.left = (max > 0 ? (slider.scrollLeft / max) * (100 - pct) : 0) + '%';
      }
      slider.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function all(scope) { (scope || document).querySelectorAll('.aurora-bp__slider-wrap').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
    else all();
    document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurora-collection-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(wrap) {
      if (wrap.dataset.clInit) return;
      var slider = wrap.querySelector('[id^="Slider-"]');
      var thumb = wrap.querySelector('.aurora-cl__progress-thumb');
      if (!slider || !thumb) return;
      wrap.dataset.clInit = '1';
      function update() {
        var max = slider.scrollWidth - slider.clientWidth;
        var pct = Math.min(100, (slider.clientWidth / slider.scrollWidth) * 100);
        thumb.style.width = pct + '%';
        thumb.style.left = (max > 0 ? (slider.scrollLeft / max) * (100 - pct) : 0) + '%';
      }
      slider.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function all(scope) { (scope || document).querySelectorAll('.aurora-cl__slider-wrap').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
    else all();
    document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurora-expanding-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('aurora-expanding-gallery')) return;
    class AuroraExpandingGallery extends HTMLElement {
      connectedCallback() {
        this.panels = Array.prototype.slice.call(this.querySelectorAll('.aurora-eg__panel'));
        if (!this.panels.length) return;
        this.idx = 0;
        var self = this;
        this.panels.forEach(function (p, i) {
          p.addEventListener('mouseenter', function () { self.activate(i); });
          p.addEventListener('focusin', function () { self.activate(i); });
          p.addEventListener('click', function () { self.activate(i); });
        });
        if (this.getAttribute('data-auto-rotate') === 'true') {
          var interval = parseInt(this.getAttribute('data-interval'), 10) || 5000;
          this.addEventListener('mouseenter', function () { self.stop(); });
          this.addEventListener('mouseleave', function () { self.start(interval); });
          this.start(interval);
        }
      }
      activate(i) {
        this.idx = i;
        this.panels.forEach(function (p, j) { p.classList.toggle('is-active', j === i); });
      }
      start(ms) {
        var self = this;
        this.stop();
        this.timer = setInterval(function () { self.activate((self.idx + 1) % self.panels.length); }, ms);
      }
      stop() { if (this.timer) clearInterval(this.timer); }
      disconnectedCallback() { this.stop(); }
    }
    customElements.define('aurora-expanding-gallery', AuroraExpandingGallery);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurora-featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(wrap) {
      if (wrap.dataset.progInit) return;
      var slider = wrap.querySelector('[id^="Slider-"]');
      var fill = wrap.querySelector('.aurora-fc__progress-thumb');
      if (!slider || !fill) return;
      wrap.dataset.progInit = '1';
      function update() {
        var max = slider.scrollWidth - slider.clientWidth;
        var thumbPct = Math.min(100, (slider.clientWidth / slider.scrollWidth) * 100);
        fill.style.width = thumbPct + '%';
        fill.style.left = (max > 0 ? (slider.scrollLeft / max) * (100 - thumbPct) : 0) + '%';
      }
      slider.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function all(scope) { (scope || document).querySelectorAll('.aurora-fc__slider-wrap').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
    else all();
    document.addEventListener('shopify:section:load', function (e) { all(e.target); });

    /* colour swatches → swap the card image to that colour's variant image, on
       BOTH hover (preview) and click (select) — same as the abc theme. */
    function swapCardImage(card, url) {
      var img = card && card.querySelector('.aurora-card__img--primary');
      if (!img || !url) return;
      img.src = url;
      img.removeAttribute('srcset');
    }
    /* hover a swatch → preview that colour's image (suppress the secondary image
       so the swap shows instantly, even with the cursor still over the card) */
    document.addEventListener('mouseover', function (e) {
      var sw = e.target.closest('.aurora-card__swatch[data-variant-image]');
      if (!sw) return;
      var card = sw.closest('.aurora-card');
      card.classList.add('is-swatch-selected');
      swapCardImage(card, sw.getAttribute('data-variant-image'));
    });
    /* leaving a swatch (not moving to another in the same card) → restore the
       currently selected/active swatch's image */
    document.addEventListener('mouseout', function (e) {
      var sw = e.target.closest('.aurora-card__swatch[data-variant-image]');
      if (!sw) return;
      var card = sw.closest('.aurora-card');
      var to = e.relatedTarget && e.relatedTarget.closest ? e.relatedTarget.closest('.aurora-card__swatch') : null;
      if (to && to.closest('.aurora-card') === card) return;
      var active = card.querySelector('.aurora-card__swatch.is-active[data-variant-image]');
      if (active) swapCardImage(card, active.getAttribute('data-variant-image'));
    });
    /* click a swatch → select it (persists after the cursor leaves) */
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('.aurora-card__swatch[data-variant-image]');
      if (!sw) return;
      var card = sw.closest('.aurora-card');
      card.classList.add('is-swatch-selected');
      swapCardImage(card, sw.getAttribute('data-variant-image'));
      card.querySelectorAll('.aurora-card__swatch').forEach(function (s) { s.classList.remove('is-active'); });
      sw.classList.add('is-active');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurora-gallery-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(wrap) {
      if (wrap.dataset.ggInit) return;
      var slider = wrap.querySelector('[id^="Slider-"]');
      var thumb = wrap.querySelector('.aurora-gg__progress-thumb');
      wrap.dataset.ggInit = '1';
      if (!slider || !thumb) return;
      function update() {
        var max = slider.scrollWidth - slider.clientWidth;
        var pct = Math.min(100, (slider.clientWidth / slider.scrollWidth) * 100);
        thumb.style.width = pct + '%';
        thumb.style.left = (max > 0 ? (slider.scrollLeft / max) * (100 - pct) : 0) + '%';
      }
      slider.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function all(scope) { (scope || document).querySelectorAll('.aurora-gg__slider-wrap').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
    else all();
    document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurora-logo-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(wrap) {
      if (wrap.dataset.llInit) return;
      var slider = wrap.querySelector('[id^="Slider-"]');
      var thumb = wrap.querySelector('.aurora-ll__progress-thumb');
      wrap.dataset.llInit = '1';
      if (!slider || !thumb) return;
      function update() {
        var max = slider.scrollWidth - slider.clientWidth;
        var pct = Math.min(100, (slider.clientWidth / slider.scrollWidth) * 100);
        thumb.style.width = pct + '%';
        thumb.style.left = (max > 0 ? (slider.scrollLeft / max) * (100 - pct) : 0) + '%';
      }
      slider.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function all(scope) { (scope || document).querySelectorAll('.aurora-ll__slider-wrap').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
    else all();
    document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurora-multicolumn"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(wrap) {
      if (wrap.dataset.mcInit) return;
      var slider = wrap.querySelector('[id^="Slider-"]');
      var thumb = wrap.querySelector('.aurora-mc__progress-thumb');
      wrap.dataset.mcInit = '1';
      if (!slider || !thumb) return;
      function update() {
        var max = slider.scrollWidth - slider.clientWidth;
        var pct = Math.min(100, (slider.clientWidth / slider.scrollWidth) * 100);
        thumb.style.width = pct + '%';
        thumb.style.left = (max > 0 ? (slider.scrollLeft / max) * (100 - pct) : 0) + '%';
      }
      slider.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function all(scope) { (scope || document).querySelectorAll('.aurora-mc__slider-wrap').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
    else all();
    document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurora-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // adapt height — size EACH slide to max(image height, content height), then
    // size the slider to whichever slide is showing. So a tall neighbour never
    // leaves a gap and long content / spacers never get clipped.
    function initAdaptHeight(comp) {
      if (comp.dataset.auroraAdaptInit) return;
      var dAdapt = comp.classList.contains('aurora-slideshow--d-adapt');
      var mAdapt = comp.classList.contains('aurora-slideshow--m-adapt');
      if (!dAdapt && !mAdapt) return;
      var slider = comp.querySelector('[id^="Slider-"]');
      if (!slider) return;
      comp.dataset.auroraAdaptInit = '1';

      function adaptNow() {
        return window.matchMedia('(max-width: 749px)').matches ? mAdapt : dAdapt;
      }

      function recalc() {
        var width = slider.clientWidth;
        var slides = slider.querySelectorAll('.slideshow__slide');
        if (!adaptNow()) {
          for (var k = 0; k < slides.length; k++) slides[k].style.height = '';
          slider.style.height = '';
          return;
        }
        if (!width) return;
        var mobile = window.matchMedia('(max-width: 749px)').matches;
        var prop = mobile ? '--ar-m' : '--ar-d';
        for (var i = 0; i < slides.length; i++) {
          var s = slides[i];
          var ar = parseFloat(getComputedStyle(s).getPropertyValue(prop)) || 0;
          var imgH = ar > 0 ? width / ar : 0;
          var content = s.querySelector('.aurora-slide__content');
          var wrap = s.querySelector('.aurora-slide__content-wrap');
          var pad = 0;
          if (wrap) {
            var cs = getComputedStyle(wrap);
            pad = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
          }
          var contentH = content ? content.scrollHeight + pad : 0;
          s.style.height = Math.max(imgH, contentH) + 'px';
        }
        sync();
      }

      function sync() {
        if (!adaptNow()) { slider.style.height = ''; return; }
        var width = slider.clientWidth;
        if (!width) return;
        var slides = slider.querySelectorAll('.slideshow__slide');
        var idx = Math.round(slider.scrollLeft / width);
        var active = slides[idx] || slides[0];
        if (active && active.offsetHeight) slider.style.height = active.offsetHeight + 'px';
      }

      var t1, t2;
      slider.addEventListener('scroll', function () { clearTimeout(t1); t1 = setTimeout(sync, 90); }, { passive: true });
      window.addEventListener('resize', function () { clearTimeout(t2); t2 = setTimeout(recalc, 120); });
      comp.addEventListener('slideChanged', sync);
      var imgs = slider.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        if (!imgs[i].complete) imgs[i].addEventListener('load', recalc, { once: true });
      }
      recalc();
      setTimeout(recalc, 250);
      setTimeout(recalc, 800);
    }

    // Seamless FORWARD loop (like the Broadcast/Flickity wrapAround): append a clone
    // of the first slide after the last, so advancing past the end moves FORWARD into
    // a copy of slide 1 — then we instantly snap scrollLeft back to the real first
    // slide (invisible, since the clone is identical). No more backward rewind.
    function initForwardLoop(comp) {
      if (comp.dataset.auroraFwdInit) return;
      var slider = comp.querySelector('[id^="Slider-"]');
      if (!slider) return;
      var reals = slider.querySelectorAll('[id^="Slide-"]');
      if (reals.length < 2) return; // nothing to loop
      comp.dataset.auroraFwdInit = '1';

      var realCount = reals.length; // the clone will sit at index realCount
      var clone = reals[0].cloneNode(true);
      clone.id = reals[0].id + '-loopclone'; // keeps the "Slide-" prefix so Dawn counts it
      clone.setAttribute('data-aurora-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.classList.remove('is-active');
      var foc = clone.querySelectorAll('a, button, [tabindex]');
      for (var f = 0; f < foc.length; f++) foc[f].setAttribute('tabindex', '-1');
      slider.appendChild(clone);

      // a matching HIDDEN dot so Dawn's dot indexing stays in bounds on the clone page
      var dotsWrap = comp.querySelector('.slideshow__control-wrapper');
      if (dotsWrap) {
        var dots = dotsWrap.querySelectorAll('.slider-counter__link');
        if (dots.length) {
          var d = dots[0].cloneNode(true);
          d.setAttribute('data-aurora-clone-dot', '');
          d.setAttribute('tabindex', '-1');
          d.setAttribute('aria-hidden', 'true');
          d.style.display = 'none';
          dotsWrap.appendChild(d);
        }
      }

      // let Dawn recount slides + dots now that the clone exists
      if (typeof comp.resetPages === 'function') { try { comp.resetPages(); } catch (e) {} }

      function snapToStart() {
        var b = slider.style.scrollBehavior;
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = 0;
        void slider.offsetWidth;
        slider.style.scrollBehavior = b || '';
      }

      // when the slider settles ON the clone, jump instantly back to the real first slide
      var tt;
      slider.addEventListener('scroll', function () {
        clearTimeout(tt);
        tt = setTimeout(function () {
          var w = slider.clientWidth;
          if (w && Math.round(slider.scrollLeft / w) >= realCount) snapToStart();
        }, 60);
      }, { passive: true });

      // prev on the first slide would dead-end into the clone — send it to the last real slide
      var prev = comp.querySelector('[name="previous"]');
      if (prev) prev.addEventListener('click', function () {
        var w = slider.clientWidth;
        if (w && Math.round(slider.scrollLeft / w) === 0) {
          setTimeout(function () {
            var b = slider.style.scrollBehavior;
            slider.style.scrollBehavior = 'auto';
            slider.scrollLeft = (realCount - 1) * slider.clientWidth;
            void slider.offsetWidth;
            slider.style.scrollBehavior = b || '';
          }, 0);
        }
      });
    }

    // Copy animation: the active slide's heading / text / button rise + fade in. We
    // toggle `is-active` on whichever slide is showing (the clone is skipped).
    function initActiveSlide(comp) {
      if (comp.dataset.auroraActiveInit) return;
      var slider = comp.querySelector('[id^="Slider-"]');
      if (!slider) return;
      comp.dataset.auroraActiveInit = '1';

      function mark() {
        var w = slider.clientWidth;
        if (!w) return;
        var slides = slider.querySelectorAll('.slideshow__slide');
        var idx = Math.round(slider.scrollLeft / w);
        // on the appended clone → treat as slide 1, so the real first slide keeps its
        // animation (it plays off-screen during the loop) and the snap-back doesn't flicker
        if (slides[idx] && slides[idx].hasAttribute('data-aurora-clone')) idx = 0;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].hasAttribute('data-aurora-clone')) continue; // never animate the clone
          if (i === idx) {
            if (!slides[i].classList.contains('is-active')) {
              slides[i].classList.remove('is-active');
              void slides[i].offsetWidth; // restart the keyframe
              slides[i].classList.add('is-active');
            }
          } else {
            slides[i].classList.remove('is-active');
          }
        }
      }
      var ta;
      slider.addEventListener('scroll', function () { clearTimeout(ta); ta = setTimeout(mark, 60); }, { passive: true });
      comp.addEventListener('slideChanged', mark);
      mark();
    }

    // background videos: some browsers (and the theme editor) won't honour the
    // declarative autoplay, so force muted playback ourselves.
    function initVideos(comp) {
      var vids = comp.querySelectorAll('video.aurora-slide__video');
      for (var i = 0; i < vids.length; i++) {
        var v = vids[i];
        v.muted = true;
        v.setAttribute('muted', '');
        v.playsInline = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    }

    function init() {
      var all = document.querySelectorAll('slideshow-component.aurora-slideshow');
      for (var i = 0; i < all.length; i++) {
        initAdaptHeight(all[i]);
        initForwardLoop(all[i]);
        initActiveSlide(all[i]);
        initVideos(all[i]);
      }
    }

    // theme editor re-renders the whole section on edits — re-initialise it.
    // (the clone/dot aren't re-rendered by the editor, so no need to strip them here)
    document.addEventListener('shopify:section:load', function (event) {
      var scope = event.target || document;
      var comps = scope.querySelectorAll('slideshow-component.aurora-slideshow');
      for (var i = 0; i < comps.length; i++) {
        comps[i].removeAttribute('data-aurora-adapt-init');
        initAdaptHeight(comps[i]);
        initForwardLoop(comps[i]);
        initActiveSlide(comps[i]);
        initVideos(comps[i]);
      }
    });

    // theme editor: when a block (slide, or anything nested in a slide like a button)
    // is selected, jump the slider to THAT slide so the slide you're editing stays in
    // view. Horizontal scroll only (no scrollIntoView) so the page never jumps to the
    // bottom and back. Dawn's slideshow has no block-select handling of its own.
    function showSlideForBlock(blockEl) {
      if (!blockEl || !blockEl.closest) return;
      var comp = blockEl.closest('slideshow-component.aurora-slideshow');
      if (!comp) return;
      var slider = comp.querySelector('[id^="Slider-"]');
      var slide = blockEl.closest('.slideshow__slide');
      if (!slider || !slide) return;
      var slides = Array.prototype.slice.call(slider.querySelectorAll('.slideshow__slide'));
      var idx = slides.indexOf(slide);
      if (idx < 0 || !slider.clientWidth) return;
      var prev = slider.style.scrollBehavior;
      slider.style.scrollBehavior = 'auto';
      slider.scrollLeft = idx * slider.clientWidth;
      comp.dispatchEvent(new CustomEvent('slideChanged'));
      setTimeout(function () { slider.style.scrollBehavior = prev; }, 60);
    }
    document.addEventListener('shopify:block:select', function (event) {
      showSlideForBlock(event.target);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
        // `scrolled-past-header` was only ever toggled by onScroll, which needs the scroll
        // position to CHANGE. A page that opens already scrolled — back navigation
        // restoring position, an anchor link, a reload part-way down — kept the
        // transparent-header state with content sitting behind it. Settle the state once
        // as soon as the bounds are known.
        this.syncScrolledState();
      });

      observer.observe(this.header);
    }

    syncScrolledState() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (!this.headerBounds || this.headerBounds.bottom === undefined) return;
      this.header.classList.toggle('scrolled-past-header', scrollTop > this.headerBounds.bottom);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      // legacy details-modal is gone; close the Aurora search drawer if it's open
      if (window.AuroraSearch && typeof window.AuroraSearch.close === 'function') {
        window.AuroraSearch.close();
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Open desktop dropdown / mega menu on hover when enabled (header--mega-hover) */
  (function () {
    function initHoverMenus() {
      var header = document.querySelector('.header--mega-hover');
      if (!header) return;
      header.querySelectorAll('header-menu').forEach(function (hm) {
        var details = hm.querySelector('details');
        if (!details || hm.dataset.hoverWired) return;
        hm.dataset.hoverWired = '1';
        hm.addEventListener('mouseenter', function () { details.open = true; });
        hm.addEventListener('mouseleave', function () { details.open = false; });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHoverMenus);
    } else {
      initHoverMenus();
    }
    document.addEventListener('shopify:section:load', initHoverMenus);
  })();

  } catch(e) { console.error(e); }
})();
})();
